import { useState } from "react"

export const PersonalizationState = () => {

    const [walkthrough, setWalkthrough] = useState({
        onboarding: false,
        createBranch: false, 
        createCategory: false , 
        createProduct: false , 
        createBranchProduct: false , 
        createBranchUser: false , 
        dashboardReport: false,
        branchProductReport: false,
        branchSalesReport: false,
        eodSalesReport: false,
        order: false,
        checkout: false,
    })

    const [personalization, setPersonalization] = useState()

    const [startHere, setStartHere] = useState({show: true, modal: false, tasks: []},)

    return {
        walkthrough: {data: walkthrough, set: setWalkthrough},
        startHere: {data: startHere, set: setStartHere},
        personalization: {data: personalization, set: setPersonalization},
    }
}